import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

type DateType = 'createdAt' | 'completedAt' | 'estimatedCompletion';

interface DateTypeToggleProps {
  value: DateType;
  isReportsPage: boolean;
  onChange: (type: DateType) => void;
  fullWidth?: boolean;
  /** Compacto: py 0.75 em vez de 1 (usado na versão expandida de desktop) */
  dense?: boolean;
}

/**
 * Toggle "Data de Abertura" / "Data de Conclusão" (relatórios) ou "Prazo Estimado" (demandas).
 * Reutilizado nas 3 variantes de AdvancedFilters (mobile, compacta, expandida). Extraído de
 * AdvancedFilters.tsx (F7).
 */
export const DateTypeToggle: React.FC<DateTypeToggleProps> = ({
  value,
  isReportsPage,
  onChange,
  fullWidth,
  dense,
}) => {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, newValue) => {
        if (newValue !== null) {
          onChange(newValue as DateType);
        }
      }}
      {...(fullWidth !== undefined ? { fullWidth } : {})}
      size="small"
      sx={{
        '& .MuiToggleButton-root': {
          py: dense ? 0.75 : 1,
          px: 2,
          fontWeight: 'medium',
          textTransform: 'none',
          border: '1px solid',
          borderColor: 'divider',
          '&.Mui-selected': {
            backgroundColor: 'primary.main',
            color: 'primary.contrastText',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          },
          '&:not(.Mui-selected)': {
            color: 'text.primary',
            backgroundColor: 'background.paper',
            '&:hover': {
              backgroundColor: 'action.hover',
            },
          },
        },
      }}
    >
      {isReportsPage ? (
        <>
          <ToggleButton value="createdAt" aria-label="Data de Abertura">
            Data de Abertura
          </ToggleButton>
          <ToggleButton value="completedAt" aria-label="Data de Conclusão">
            Data de Conclusão
          </ToggleButton>
        </>
      ) : (
        <>
          <ToggleButton value="createdAt" aria-label="Data de Abertura">
            Data de Abertura
          </ToggleButton>
          <ToggleButton value="estimatedCompletion" aria-label="Prazo Estimado">
            Prazo Estimado
          </ToggleButton>
        </>
      )}
    </ToggleButtonGroup>
  );
};

export default DateTypeToggle;
